module.exports = __webpack_public_path__ + "static/media/fetal-pillow-brochure@3x.2cb6041f.png";